import { render, staticRenderFns } from "./TopCategoriesByCompany.vue?vue&type=template&id=54ea8637"
import script from "./TopCategoriesByCompany.vue?vue&type=script&lang=ts"
export * from "./TopCategoriesByCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports